var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.022,
    height: 162.022,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0057ff",
    d: "M0 0h162.022v162.022H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.632 18.873c4.084-.716 8.289.118 11.791 2.339 4.874 3.674 8.462 8.795 10.252 14.631 1.929 7.365-2.9 15.436-5.8 19.913-4.642 6.561-10.246 16.964-12.947 21.79-1.74 3.2-3.876 4.974-7.545 1.74-2.954-2.226-4.677-5.721-4.642-9.42 0-4.1 2.513-11.493 8.9-20.517l1.558-2.453 1.023-1.655c3.867-6.343 6.989-12.544 4.77-13.774-7.155-4.068-49.495 28.854-50.462 50.359-.584 12.346 25.906 19.433 33.438 23.643 3.681 2.114 5.811 5.181 5.811 8.71 0 4.275-2.519 9.438-7.545 15.868-5.032 6.241-14.5 11.4-26.1 12.932-14.115 1.871-32.867-3.263-48.144-18.149-2.7-2.812-1.351-5.033 1.357-6.317 1.944-.664 3.953-1.119 5.993-1.356 5.61-.746 11.018.03 15.077 2.653 7.545 4.951 20.309 12.553 31.516 11.067 4.253-.563 8.123-2 10.258-4.328 2.89-3.18 1.922-6.389-.2-7.787-4.439-2.544-9.005-4.859-13.681-6.935l-2.31-1.1c-12.345-5.936-24.8-13.06-24.8-25.969 0-25.278 30.159-51.384 47.566-60.757 6.36-3.446 10.425-4.541 14.866-5.128z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp04);
export default __webpack_public_path__ + "static/media/scrumlr-lp-04.478806fe074dc6948b5e4364ef879de6.svg";
export { ForwardRef as ReactComponent };